import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { TooltipIconComponent } from 'src/app/shared/tooltip-icon/tooltip-icon.component';

export interface CategoryItem {
  icon?: string;
  value: string;
  label: string;
  description?: string;
  tooltipMessage?: string;
}
@Component({
  selector: 'app-category-selector',
  imports: [CommonModule, LucideAngularModule, TooltipIconComponent],
  templateUrl: './category-selector.component.html',
})
export class CategorySelectorComponent {
  @Input() type: 'card' | 'list' | 'scroll' = 'card';
  @Input() shadow: boolean = false;
  @Input() categoryList: CategoryItem[] = [];
  @Input() orientation: 'row' | 'col' = 'row';
  private _selectedValue: string | null = null;

  @Input()
  get selectedValue(): string | null {
    return this._selectedValue;
  }
  set selectedValue(value: string | null) {
    this._selectedValue = value;
    this.selectedItemIndex = this.categoryList.findIndex(
      (c) => c.value === value,
    );
  }
  @Output() selectedValueChange = new EventEmitter<string | null>();

  selectedItemIndex?: number;

  handleClick(index: number) {
    const item = this.categoryList[index];
    this.selectedItemIndex = index;
    this._selectedValue = item.value;
    this.selectedValueChange.emit(item.value);
  }

  isSelected(index: number) {
    return this.selectedItemIndex === index;
  }
}
